import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,{attrs:{"align":"center","justify":"space-between"}},[_c(VCol,{attrs:{"cols":"2","align":"end"}},[_c(VBtn,{attrs:{"color":"primary","fab":"","x-small":"","dark":""},on:{"click":_vm.lastWeek}},[_c(VIcon,[_vm._v("navigate_before")])],1)],1),_c(VCol,{attrs:{"align":"center"}},[_vm._t("datepicker")],2),_c(VCol,{attrs:{"cols":"2","align":"start"}},[_c(VBtn,{attrs:{"color":"primary","fab":"","x-small":"","dark":""},on:{"click":_vm.nextWeek}},[_c(VIcon,[_vm._v("navigate_next")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }